var render = function render(){var _vm=this,_c=_vm._self._c;return _c('entity-select-dialog',{ref:"entitySelectDialog",attrs:{"search":_vm.search,"items":_vm.items,"loading":_vm.loading},scopedSlots:_vm._u([{key:"listItem",fn:function(props){return [_c('SupplierListItem',{attrs:{"item":props.item,"showActions":false,"rowClickEnabled":true}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }